import { createSlice } from "@reduxjs/toolkit";
import { PhenylProduct } from "../../Api/Api"; // Import API function

const phenylSlice = createSlice({
    name: "phenyl",
    initialState: {
        products: [],  // Ensure initial state is an array
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(PhenylProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(PhenylProduct.fulfilled, (state, action) => {
                //console.log("Data Received in Redux:", action.payload);
                state.products = action.payload; // Ensure this is an array
                state.loading = false;
            })
            .addCase(PhenylProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default phenylSlice.reducer;
